import { createFeatureSelector, createSelector } from "@ngrx/store";
import {
  StationsTagsState,
  stationTRagsFeatureKey,
} from "./station-tags.reducer";

const selectStationsState = createFeatureSelector<StationsTagsState>(
  stationTRagsFeatureKey
);

export const selectStationTagsForm = createSelector(
  selectStationsState,
  (state) => state
);

export const selectStationTags = createSelector(selectStationsState, (state) =>
  state.loading === false && state.hasError === false
    ? { data: state.data, loading: false }
    : { data: [], loading: false }
);

export const selectStationTagsByParent = (parentName: string) =>
  createSelector(selectStationsState, (state) =>
    state.loading === false && state.hasError === false
      ? state.data.rows.filter((row: any) => row.parent === parentName)
      : []
  );
